// import React, { useState, useEffect } from "react";
// import {
//   Card,
//   Descriptions,
//   Tag,
//   Button,
//   Tabs,
//   Table,
//   Space,
//   Badge,
// } from "antd";
// import {
//   ArrowLeftOutlined,
//   EditOutlined,
//   MailOutlined,
//   PhoneOutlined,
//   UserOutlined,
// } from "@ant-design/icons";
// import { useNavigate, useParams } from "react-router-dom";
// import { useDynamicApi } from "../../hooks/useApi";
// import { API_ENDPOINTS } from "../../config/api";
// import Toast from "../../utils/toast";
// import "react-phone-input-2/lib/style.css";
// import { useTranslation } from "react-i18next";

// const { TabPane } = Tabs;

// const UserDetails = () => {
//   const { t, i18n } = useTranslation();
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [user, setUser] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [clubsList, setClubsList] = useState([]);
//   const [activeTab, setActiveTab] = useState("1");

//   // API hooks
//   const { execute: getUser, loading: userLoading } = useDynamicApi("GET");
//   const { execute: getClubs, loading: clubsLoading } = useDynamicApi("GET");

//   // User type options for labels
//   const USER_TYPE_OPTIONS = [
//     { value: "INDIVIDUAL", label: t("userManager.individual"), color: "blue" },
//     { value: "CLUB_COACH", label: t("userManager.clubCoach"), color: "green" },
//     { value: "CLUB_ADMIN", label: t("userManager.clubAdmin"), color: "purple" },
//     {
//       value: "KNKV_PARTICIPANT",
//       label: t("userManager.knkvParticipant"),
//       color: "orange",
//     },
//     {
//       value: "KNKV_INSTRUCTOR",
//       label: t("userManager.knkvInstructor"),
//       color: "red",
//     },
//     {
//       value: "SYSTEM_ADMIN",
//       label: t("userManager.systemAdmin"),
//       color: "gold",
//     },
//   ];

//   // Load clubs list
//   const loadClubs = async () => {
//     try {
//       const response = await getClubs(
//         API_ENDPOINTS.CLUBS_LIST_WITHOUT_PAGINATE,
//       );
//       if (response?.status === true && response.data) {
//         setClubsList(response.data);
//       }
//     } catch (error) {
//       console.error("Error loading clubs:", error);
//     }
//   };

//   // Load user details
//   const loadUserDetails = async () => {
//     setLoading(true);
//     try {
//       const endpoint = `${API_ENDPOINTS.USERS_UPDATE}/${id}`;
//       const response = await getUser(endpoint);

//       if (response?.status === true && response.data) {
//         setUser(response.data);
//       } else {
//         Toast.error(t("userManager.failedFetchDetails"));
//         navigate("/users");
//       }
//     } catch (error) {
//       console.error("Error fetching user details:", error);
//       Toast.error(error.message || t("userManager.failedFetchDetails"));
//       navigate("/users");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (id) {
//       loadUserDetails();
//       loadClubs();
//     }
//   }, [id]);

//   // Get club name by ID
//   const getClubName = (clubId) => {
//     if (!clubId) return "N/A";
//     const club = clubsList.find((c) => c.id === clubId);
//     return club ? club.name : "N/A";
//   };

//   // Get user type label and color
//   const getUserTypeInfo = (userType) => {
//     const option = USER_TYPE_OPTIONS.find((opt) => opt.value === userType);
//     return option || { label: userType, color: "default" };
//   };

//   // Format date
//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     const date = new Date(dateString);
//     return date.toLocaleDateString(i18n.language === "nl" ? "nl-NL" : "en-US", {
//       year: "numeric",
//       month: "long",
//       day: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//     });
//   };

//   // Format mobile number
//   // const formatMobile = (value) => {
//   //   if (!value || String(value).trim() === "") return "N/A";
//   //   let s = String(value).trim().replace(/^\+/, "").replace(/\s/g, "");
//   //   if (s.length === 0) return "N/A";
//   //   if (s.startsWith("1") && s.length > 1) return `+1 ${s.slice(1)}`;
//   //   if (s.length >= 2) return `+${s.slice(0, 2)} ${s.slice(2)}`;
//   //   return `+${s}`;
//   // };

//   const formatMobileWithCountryCode = (user) => {
//     if (!user) return "N/A";

//     // Agar country_code aur mobile_number dono available hain
//     if (user.country_code && user.mobile_number) {
//       return `${user.country_code} ${user.mobile_number}`;
//     }

//     if (user.mobile_number) {
//       return formatMobileLegacy(user.mobile_number);
//     }

//     return "N/A";
//   };

//   // Legacy format function for backward compatibility
//   const formatMobileLegacy = (value) => {
//     if (!value || String(value).trim() === "") return "N/A";
//     let s = String(value).trim().replace(/^\+/, "").replace(/\s/g, "");
//     if (s.length === 0) return "N/A";
//     if (s.startsWith("1") && s.length > 1) return `+1 ${s.slice(1)}`;
//     if (s.length >= 2) return `+${s.slice(0, 2)} ${s.slice(2)}`;
//     return `+${s}`;
//   };

//   // Check if user is club-related
//   const isClubUser = () => {
//     return (
//       user &&
//       (user.user_type === "CLUB_ADMIN" ||
//         user.user_type === "CLUB_COACH" ||
//         user.user_type === "INDIVIDUAL" ||
//         user.user_type === "KNKV_INSTRUCTOR" ||
//         user.user_type === "KNKV_PARTICIPANT")
//     );
//   };

//   if (loading || userLoading) return null;

//   if (!user) {
//     return (
//       <Card>
//         <div style={{ textAlign: "center", padding: "40px" }}>
//           <h3>{t("userManager.noUsersFound")}</h3>
//           <Button type="primary" onClick={() => navigate("/users")}>
//             {t("common.previous")} {t("userManager.title")}
//           </Button>
//         </div>
//       </Card>
//     );
//   }

//   const userTypeInfo = getUserTypeInfo(user.user_type);

//   return (
//     <div className="user-details-page">
//       {/* Header with back button and actions */}
//       <div
//         style={{
//           marginBottom: "20px",
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//         }}
//       >
//         <Space>
//           <Button
//             icon={<ArrowLeftOutlined />}
//             onClick={() => navigate("/users")}
//           >
//             {t("common.previous")} {t("userManager.title")}
//           </Button>
//           <h2 style={{ margin: 0 }}>{t("userManager.userDetails")}</h2>
//         </Space>
//       </div>

//       {/* Main Content */}
//       <Tabs activeKey={activeTab} onChange={setActiveTab}>
//         {/* Personal Information Tab */}
//         <TabPane tab={t("userManager.userDetails")} key="1">
//           <Card>
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 marginBottom: "24px",
//               }}
//             >
//               <div
//                 style={{
//                   width: "80px",
//                   height: "80px",
//                   borderRadius: "50%",
//                   backgroundColor: "#f0f2f5",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   marginRight: "24px",
//                 }}
//               >
//                 <UserOutlined style={{ fontSize: "40px", color: "#8c8c8c" }} />
//               </div>
//               <div>
//                 <h1 style={{ margin: 0, marginBottom: "8px" }}>
//                   {user.full_name}
//                 </h1>
//                 <Space size="middle">
//                   <Tag color={userTypeInfo.color}>{userTypeInfo.label}</Tag>
//                   <Badge
//                     status={user.is_active ? "success" : "default"}
//                     text={
//                       user.is_active ? t("common.active") : t("common.inactive")
//                     }
//                   />
//                 </Space>
//               </div>
//             </div>

//             <Descriptions bordered column={2}>
//               <Descriptions.Item label={t("userManager.fullName")} span={1}>
//                 {user.full_name}
//               </Descriptions.Item>
//               <Descriptions.Item label={t("userManager.emailAddress")} span={1}>
//                 {user.email ? (
//                   <Space>
//                     <MailOutlined />
//                     <a href={`mailto:${user.email}`}>{user.email}</a>
//                   </Space>
//                 ) : (
//                   "N/A"
//                 )}
//               </Descriptions.Item>

//               {/* <Descriptions.Item label={t("userManager.mobile")} span={1}>
//                 {user.mobile_number ? (
//                   <Space>
//                     <PhoneOutlined />
//                     <a href={`tel:${user.mobile_number}`}>
//                       {formatMobile(user.mobile_number)}
//                     </a>
//                   </Space>
//                 ) : (
//                   "N/A"
//                 )}
//               </Descriptions.Item> */}

//               <Descriptions.Item label={t("userManager.mobile")} span={1}>
//                 {user.mobile_number ? (
//                   <Space>
//                     <PhoneOutlined />
//                     <a
//                       href={`tel:${user.country_code ? user.country_code + user.mobile_number : user.mobile_number}`}
//                     >
//                       {formatMobileWithCountryCode(user)}
//                     </a>
//                   </Space>
//                 ) : (
//                   "N/A"
//                 )}
//               </Descriptions.Item>

//               <Descriptions.Item label={t("userManager.userType")} span={1}>
//                 <Tag color={userTypeInfo.color}>{userTypeInfo.label}</Tag>
//               </Descriptions.Item>

//               {/* {isClubUser() && (
//                 <Descriptions.Item label={t("userManager.club")} span={1}>
//                   {getClubName(user.club) || t("userManager.noClub")}
//                 </Descriptions.Item>
//               )} */}
//               <Descriptions.Item label={t("userManager.club_name")} span={1}>
//                 {user.club_name}
//               </Descriptions.Item>

//               <Descriptions.Item label={t("common.status")} span={1}>
//                 <Tag color={user.is_active ? "green" : "default"}>
//                   {user.is_active ? t("common.active") : t("common.inactive")}
//                 </Tag>
//               </Descriptions.Item>

//               <Descriptions.Item label={t("userManager.createdAt")} span={1}>
//                 {formatDate(user.created_at)}
//               </Descriptions.Item>

//               <Descriptions.Item label={t("common.lastUpdated")} span={1}>
//                 {formatDate(user.updated_at)}
//               </Descriptions.Item>
//             </Descriptions>
//           </Card>
//         </TabPane>

//         {/* Subscription Details Tab */}
//         <TabPane tab={t("dashboard.subscriptionRevenue")} key="2">
//           <Card>
//             <Descriptions bordered column={2}>
//               <Descriptions.Item label={t("common.status")} span={1}>
//                 <Tag color={user.subscription_active ? "green" : "default"}>
//                   {user.subscription_active
//                     ? t("common.active")
//                     : t("common.inactive")}
//                 </Tag>
//               </Descriptions.Item>

//               <Descriptions.Item label={t("dashboard.plan")} span={1}>
//                 {user.user_type || "N/A"}
//               </Descriptions.Item>

//               <Descriptions.Item label={t("dashboard.activationDate")} span={1}>
//                 {formatDate(user.subscription_started_at)}
//               </Descriptions.Item>

//               <Descriptions.Item label={t("dashboard.expirationDate")} span={1}>
//                 {formatDate(user.subscription_expiry)}
//               </Descriptions.Item>

//               {/* <Descriptions.Item label={t("common.description")} span={1}>
//                 {formatDate(user.trial_expiry)}
//               </Descriptions.Item>

//               <Descriptions.Item label={t("common.description")} span={1}>
//                 {user.auto_renew ? (
//                   <Tag color="green">{t("common.yes")}</Tag>
//                 ) : (
//                   <Tag color="default">{t("common.no")}</Tag>
//                 )}
//               </Descriptions.Item> */}
//             </Descriptions>

//             {user.subscription_expiry &&
//               new Date(user.subscription_expiry) < new Date() && (
//                 <div
//                   style={{
//                     marginTop: "16px",
//                     padding: "12px",
//                     backgroundColor: "#fff2f0",
//                     border: "1px solid #ffccc7",
//                     borderRadius: "6px",
//                   }}
//                 >
//                   <strong style={{ color: "#f5222d" }}>
//                     ⚠️ {t("common.description")}
//                   </strong>
//                   <p style={{ margin: "8px 0 0 0", color: "#666" }}>
//                     {t("common.description")}
//                   </p>
//                 </div>
//               )}
//           </Card>
//         </TabPane>

//         {/* Activity Log Tab (Optional - if you have activity logs) */}
//         {/* <TabPane tab={t("common.description")} key="3">
//           <Card>
//             <Table
//               dataSource={[]}
//               columns={[
//                 {
//                   title: t("dashboard.dateTime"),
//                   dataIndex: "timestamp",
//                   key: "timestamp",
//                 },
//                 {
//                   title: t("common.description"),
//                   dataIndex: "activity",
//                   key: "activity",
//                 },
//                 {
//                   title: t("common.description"),
//                   dataIndex: "ip",
//                   key: "ip",
//                 },
//               ]}
//               locale={{ emptyText: t("common.noData") }}
//             />
//           </Card>
//         </TabPane> */}
//       </Tabs>
//     </div>
//   );
// };

// export default UserDetails;

import React, { useState, useEffect } from "react";
import {
  Card,
  Descriptions,
  Tag,
  Button,
  Tabs,
  Table,
  Space,
  Badge,
} from "antd";
import {
  ArrowLeftOutlined,
  EditOutlined,
  MailOutlined,
  PhoneOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { useDynamicApi } from "../../hooks/useApi";
import { API_ENDPOINTS } from "../../config/api";
import Toast from "../../utils/toast";
import "react-phone-input-2/lib/style.css";
import { useTranslation } from "react-i18next";

const { TabPane } = Tabs;

const UserDetails = () => {
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [clubsList, setClubsList] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  const [imgError, setImgError] = useState(false); // NEW

  // API hooks
  const { execute: getUser, loading: userLoading } = useDynamicApi("GET");
  const { execute: getClubs, loading: clubsLoading } = useDynamicApi("GET");

  // User type options for labels
  const USER_TYPE_OPTIONS = [
    { value: "INDIVIDUAL", label: t("userManager.individual"), color: "blue" },
    { value: "CLUB_COACH", label: t("userManager.clubCoach"), color: "green" },
    { value: "CLUB_ADMIN", label: t("userManager.clubAdmin"), color: "purple" },
    {
      value: "KNKV_PARTICIPANT",
      label: t("userManager.knkvParticipant"),
      color: "orange",
    },
    {
      value: "KNKV_INSTRUCTOR",
      label: t("userManager.knkvInstructor"),
      color: "red",
    },
    {
      value: "SYSTEM_ADMIN",
      label: t("userManager.systemAdmin"),
      color: "gold",
    },
  ];

  // Load clubs list
  const loadClubs = async () => {
    try {
      const response = await getClubs(
        API_ENDPOINTS.CLUBS_LIST_WITHOUT_PAGINATE,
      );
      if (response?.status === true && response.data) {
        setClubsList(response.data);
      }
    } catch (error) {
      console.error("Error loading clubs:", error);
    }
  };

  // Load user details
  const loadUserDetails = async () => {
    setLoading(true);
    try {
      const endpoint = `${API_ENDPOINTS.USERS_UPDATE}/${id}`;
      const response = await getUser(endpoint);

      if (response?.status === true && response.data) {
        setUser(response.data);
      } else {
        Toast.error(t("userManager.failedFetchDetails"));
        navigate("/users");
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
      Toast.error(error.message || t("userManager.failedFetchDetails"));
      navigate("/users");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      loadUserDetails();
      loadClubs();
    }
  }, [id]);

  // Reset image error when user changes
  useEffect(() => {
    setImgError(false);
  }, [user?.id]);

  // Get club name by ID
  const getClubName = (clubId) => {
    if (!clubId) return "N/A";
    const club = clubsList.find((c) => c.id === clubId);
    return club ? club.name : "N/A";
  };

  // Get user type label and color
  const getUserTypeInfo = (userType) => {
    const option = USER_TYPE_OPTIONS.find((opt) => opt.value === userType);
    return option || { label: userType, color: "default" };
  };

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString(i18n.language === "nl" ? "nl-NL" : "en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const formatMobileWithCountryCode = (user) => {
    if (!user) return "N/A";
    if (user.country_code && user.mobile_number) {
      return `${user.country_code} ${user.mobile_number}`;
    }
    if (user.mobile_number) {
      return formatMobileLegacy(user.mobile_number);
    }
    return "N/A";
  };

  const formatMobileLegacy = (value) => {
    if (!value || String(value).trim() === "") return "N/A";
    let s = String(value).trim().replace(/^\+/, "").replace(/\s/g, "");
    if (s.length === 0) return "N/A";
    if (s.startsWith("1") && s.length > 1) return `+1 ${s.slice(1)}`;
    if (s.length >= 2) return `+${s.slice(0, 2)} ${s.slice(2)}`;
    return `+${s}`;
  };

  // Check if user is club-related (optional, kept for compatibility)
  const isClubUser = () => {
    return (
      user &&
      (user.user_type === "CLUB_ADMIN" ||
        user.user_type === "CLUB_COACH" ||
        user.user_type === "INDIVIDUAL" ||
        user.user_type === "KNKV_INSTRUCTOR" ||
        user.user_type === "KNKV_PARTICIPANT")
    );
  };

  if (loading || userLoading) return null;

  if (!user) {
    return (
      <Card>
        <div style={{ textAlign: "center", padding: "40px" }}>
          <h3>{t("userManager.noUsersFound")}</h3>
          <Button type="primary" onClick={() => navigate("/users")}>
            {t("common.previous")} {t("userManager.title")}
          </Button>
        </div>
      </Card>
    );
  }

  const userTypeInfo = getUserTypeInfo(user.user_type);

  return (
    <div className="user-details-page">
      {/* Header with back button and actions */}
      <div
        style={{
          marginBottom: "20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Space>
          <Button
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate("/users")}
          >
            {t("common.previous")} {t("userManager.title")}
          </Button>
          <h2 style={{ margin: 0 }}>{t("userManager.userDetails")}</h2>
        </Space>
      </div>

      {/* Main Content */}
      <Tabs activeKey={activeTab} onChange={setActiveTab}>
        {/* Personal Information Tab */}
        <TabPane tab={t("userManager.userDetails")} key="1">
          <Card>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "24px",
              }}
            >
              <div
                style={{
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  backgroundColor: "#f0f2f5",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "24px",
                  overflow: "hidden",
                }}
              >
                {user.profile_picture_url && !imgError ? (
                  <img
                    src={user.profile_picture_url}
                    alt={user.full_name || "Profile"}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                    onError={() => setImgError(true)}
                  />
                ) : (
                  <UserOutlined
                    style={{ fontSize: "40px", color: "#8c8c8c" }}
                  />
                )}
              </div>
              <div>
                <h1 style={{ margin: 0, marginBottom: "8px" }}>
                  {user.full_name}
                </h1>
                <Space size="middle">
                  <Tag color={userTypeInfo.color}>{userTypeInfo.label}</Tag>
                  <Badge
                    status={user.is_active ? "success" : "default"}
                    text={
                      user.is_active ? t("common.active") : t("common.inactive")
                    }
                  />
                </Space>
              </div>
            </div>

            <Descriptions bordered column={2}>
              <Descriptions.Item label={t("userManager.fullName")} span={1}>
                {user.full_name}
              </Descriptions.Item>
              <Descriptions.Item label={t("userManager.emailAddress")} span={1}>
                {user.email ? (
                  <Space>
                    <MailOutlined />
                    <a href={`mailto:${user.email}`}>{user.email}</a>
                  </Space>
                ) : (
                  "N/A"
                )}
              </Descriptions.Item>

              <Descriptions.Item label={t("userManager.mobile")} span={1}>
                {user.mobile_number ? (
                  <Space>
                    <PhoneOutlined />
                    <a
                      href={`tel:${user.country_code ? user.country_code + user.mobile_number : user.mobile_number}`}
                    >
                      {formatMobileWithCountryCode(user)}
                    </a>
                  </Space>
                ) : (
                  "N/A"
                )}
              </Descriptions.Item>

              <Descriptions.Item label={t("userManager.userType")} span={1}>
                <Tag color={userTypeInfo.color}>{userTypeInfo.label}</Tag>
              </Descriptions.Item>

              <Descriptions.Item label={t("userManager.club_name")} span={1}>
                {user.club_name}
              </Descriptions.Item>

              <Descriptions.Item label={t("common.status")} span={1}>
                <Tag color={user.is_active ? "green" : "default"}>
                  {user.is_active ? t("common.active") : t("common.inactive")}
                </Tag>
              </Descriptions.Item>

              <Descriptions.Item label={t("userManager.createdAt")} span={1}>
                {formatDate(user.created_at)}
              </Descriptions.Item>

              <Descriptions.Item label={t("common.lastUpdated")} span={1}>
                {formatDate(user.updated_at)}
              </Descriptions.Item>
            </Descriptions>
          </Card>
        </TabPane>

        {/* Subscription Details Tab */}
        <TabPane tab={t("dashboard.subscriptionRevenue")} key="2">
          <Card>
            <Descriptions bordered column={2}>
              <Descriptions.Item label={t("common.status")} span={1}>
                <Tag color={user.subscription_active ? "green" : "default"}>
                  {user.subscription_active
                    ? t("common.active")
                    : t("common.inactive")}
                </Tag>
              </Descriptions.Item>

              <Descriptions.Item label={t("dashboard.plan")} span={1}>
                {user.user_type || "N/A"}
              </Descriptions.Item>

              <Descriptions.Item label={t("dashboard.activationDate")} span={1}>
                {formatDate(user.subscription_started_at)}
              </Descriptions.Item>

              <Descriptions.Item label={t("dashboard.expirationDate")} span={1}>
                {formatDate(user.subscription_expiry)}
              </Descriptions.Item>
            </Descriptions>

            {user.subscription_expiry &&
              new Date(user.subscription_expiry) < new Date() && (
                <div
                  style={{
                    marginTop: "16px",
                    padding: "12px",
                    backgroundColor: "#fff2f0",
                    border: "1px solid #ffccc7",
                    borderRadius: "6px",
                  }}
                >
                  <strong style={{ color: "#f5222d" }}>
                    ⚠️ {t("common.description")}
                  </strong>
                  <p style={{ margin: "8px 0 0 0", color: "#666" }}>
                    {t("common.description")}
                  </p>
                </div>
              )}
          </Card>
        </TabPane>
      </Tabs>
    </div>
  );
};

export default UserDetails;
